import { Popover as AntdPopover } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Label01, ProductiveHeading07 } from 'components/styles';

const PopoverHeading = styled.p`
  ${ProductiveHeading07};
  margin-bottom: 0px;
`;

const PopoverSubHeading = styled.span`
  ${Label01};
  font-weight: normal;
  color: var(--gray-80);
`;

const Popover = styled(AntdPopover)`
  &&.ant-popover-inner-content {
    color: var(--gray-80);
  }
`;

interface StatusPopoverProps {
  title?: ReactNode;
  subTitle?: string;
  content?: any;
  placement?: TooltipPlacement;
}
export const StatusPopover: FC<StatusPopoverProps> = ({
  title,
  subTitle,
  content,
  children,
  placement = 'leftTop' as TooltipPlacement,
}) => {
  const Heading = (
    <>
      {title && <PopoverHeading> {title} </PopoverHeading>}
      {subTitle && <PopoverSubHeading> {subTitle} </PopoverSubHeading>}
    </>
  );

  if (children) {
    return (
      <Popover
        title={Heading}
        content={() => content}
        placement={placement}
        destroyTooltipOnHide
      >
        {children}
      </Popover>
    );
  }

  return <></>;
};
